export interface SupportInputs {
  enabled: boolean;
  hasGetUserMedia: boolean;
  hasMediaRecorder: boolean;
  isMobile: boolean;
}

export type Support =
  | { available: true }
  | { available: false; reason: 'disabled' }
  | { available: false; reason: 'unsupported' };

export function checkShowAndTellSupport(inputs: SupportInputs): Support {
  if (!inputs.enabled) return { available: false, reason: 'disabled' };
  if (!inputs.hasGetUserMedia || !inputs.hasMediaRecorder || inputs.isMobile) {
    return { available: false, reason: 'unsupported' };
  }
  return { available: true };
}

/** Reads the real browser and the build flag. Kept apart from the check so the check stays pure. */
export function detectShowAndTellSupport(): Support {
  const hasWindow = typeof window !== 'undefined' && typeof navigator !== 'undefined';
  return checkShowAndTellSupport({
    enabled: import.meta.env.VITE_SHOW_TELL_ENABLED === 'true',
    hasGetUserMedia: hasWindow && typeof navigator.mediaDevices?.getUserMedia === 'function',
    hasMediaRecorder: hasWindow && typeof MediaRecorder !== 'undefined',
    isMobile: hasWindow && /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent),
  });
}
